// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e5426ef3","348":"abb9a733"}[chunkId] + ".chunk.js";
};